import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ChecklistDesktopTask from './ChecklistDesktopTask';
import ChecklistMobileTask from './ChecklistMobileTask';
import ChecklistEmptyState from '../ChecklistEmptyState';

import scrollViewTo from '../../../../util/scrollViewTo';
import { isDesktop } from '../../../../lib/responsive';

import './ChecklistTask.less';

// TODO: connect desktop/mobile independently so we don't have to pass down so many props
// However, this component is still useful for showing an empty state
class ChecklistTask extends Component {
  constructor() {
    super();
    this.taskRef = React.createRef();
  }

  componentDidMount() {
    const { taskId, trackView, title } = this.props;

    // this check handles the task mounting before data is returned on load
    if (taskId && title) trackView(taskId);
  }

  componentDidUpdate(prevProps) {
    const { trackView } = this.props;

    const didTaskChange = prevProps.taskId !== this.props.taskId;

    if (didTaskChange) {
      // on task change, track a Task Viewed event
      trackView(this.props.taskId);

      const containerId = isDesktop() ? 'checklistContainerRight' : 'checklistTaskMobileContent';
      scrollViewTo({ el: this.taskRef.current, containerId, behavior: 'smooth' });
    }
  }

  renderEmptyOrContent = () => {
    const { title } = this.props;

    // If no title exists, this task has likely been deleted since title is required
    if (!title) {
      return (
        <div className="checklist__task-emptyState">
          <ChecklistEmptyState description="Select a task to get started" />
        </div>
      );
    }

    return (
      <React.Fragment>
        {this.renderDesktop()}
        {this.renderMobile()}
      </React.Fragment>
    );
  };

  renderDesktop = () => {
    const {
      taskId,
      isCustomTask,
      title,
      description,
      url,
      urlText,
      sponsoredLink,
      sponsoredLinkText,
      editCustomTask,
      isSponsoredLinkFromZola,
    } = this.props;

    return (
      <ChecklistDesktopTask
        taskId={taskId}
        isCustomTask={isCustomTask}
        title={title}
        description={description}
        url={url}
        urlText={urlText}
        sponsoredLink={sponsoredLink}
        sponsoredLinkText={sponsoredLinkText}
        editCustomTask={editCustomTask}
        isSponsoredLinkFromZola={isSponsoredLinkFromZola}
      />
    );
  };

  renderMobile = () => {
    const {
      mobileCloseTask,
      isCustomTask,
      title,
      description,
      url,
      urlText,
      sponsoredLink,
      sponsoredLinkText,
      isSponsoredLinkFromZola,
      invitePartnerViewActive,
    } = this.props;

    return (
      <ChecklistMobileTask
        closeTask={mobileCloseTask}
        isCustomTask={isCustomTask}
        title={title}
        description={description}
        url={url}
        urlText={urlText}
        sponsoredLink={sponsoredLink}
        sponsoredLinkText={sponsoredLinkText}
        isSponsoredLinkFromZola={isSponsoredLinkFromZola}
        invitePartnerViewActive={invitePartnerViewActive}
      />
    );
  };

  render() {
    const { title } = this.props;
    return (
      <div
        ref={this.taskRef}
        className="checklist__task-container"
        data-testId={`weddingChecklist__taskView__${title}`}
      >
        {this.renderEmptyOrContent()}
      </div>
    );
  }
}

ChecklistTask.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  mobileCloseTask: PropTypes.func,
  url: PropTypes.string,
  urlText: PropTypes.string,
  sponsoredLink: PropTypes.string,
  sponsoredLinkText: PropTypes.string,
  isCustomTask: PropTypes.bool,
  isSponsoredLinkFromZola: PropTypes.bool,
  editCustomTask: PropTypes.func,
  trackView: PropTypes.func,
  invitePartnerViewActive: PropTypes.bool,
};

ChecklistTask.defaultProps = {
  title: '',
  trackView: () => {},
};

export default ChecklistTask;



// WEBPACK FOOTER //
// ./src/components/manage/ChecklistV2/ChecklistTask/ChecklistTask.jsx